import type { WorkflowPhase } from '@internal/plugin-argo-workflows';

export const STATUS_COLORS = {
  success: '#388e3c',
  successLight: '#43a047',
  error: '#d32f2f',
  errorLight: '#e53935',
  warning: '#e65100',
  running: '#fdd835',
  muted: '#78909c',
  neutral: '#546e7a',
} as const;

export const ENV_TIER_COLORS = {
  alpha: '#039be5',
  staging: '#b39ddb',
  production: '#e0e0e0',
} as const;

export const CONTROL_BAR = {
  bg: '#1a2332',
  chipBg: '#253347',
  chipText: '#cfd8dc',
  divider: '#37474f',
} as const;

export function envTierColor(envName: string): string {
  if (envName === 'Alpha') return ENV_TIER_COLORS.alpha;
  if (envName.startsWith('Staging') || envName === 'Gamma') return ENV_TIER_COLORS.staging;
  if (envName.startsWith('Production')) return ENV_TIER_COLORS.production;
  return CONTROL_BAR.chipText;
}

export function envTierTextColor(_envName: string): string {
  return '#1a2332';
}

export const PHASE_STATUS_COLOR: Record<WorkflowPhase, string> = {
  Pending: STATUS_COLORS.muted,
  Running: STATUS_COLORS.running,
  Succeeded: STATUS_COLORS.success,
  Failed: STATUS_COLORS.error,
  Error: STATUS_COLORS.error,
  Unknown: STATUS_COLORS.muted,
};
